import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthenticationRequest, User } from '../../models/authentication.interface';
import { ButtonComponent } from '../../shared/button/button.component';
import { InputIconComponent } from '../../shared/input-icon/input-icon.component';
import { LoaderService } from '../../shared/loader/loader.service';
import { Menu } from '../../shared/menu/menu.component';
import { MenuService } from '../../shared/menu/menu.service';
import { ModalService } from '../../shared/modal/modal.service';
import { UserService } from '../../shared/services/user/user.service';
import { ToastService } from '../../shared/toast/toast.service';
import { AuthService } from '../services/auth.service';
import { TermosPrivacidadeComponent } from '../termos-privacidade/termos-privacidade.component';
import { StorageServiceService } from './../../shared/storage/storage-service.service';

@Component({
  selector: 'app-login',
  standalone: true,
  host: { class: 'main' },
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [
    ButtonComponent,
    InputIconComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class LoginComponent implements OnInit, AfterViewInit {
  campoObrigatorio: boolean = false;
  formLogin = new FormGroup({
    identifier: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    private readonly router: Router,
    private readonly modalService: ModalService,
    private readonly menuService: MenuService,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly loaderService: LoaderService,
    private readonly storage: StorageServiceService,
  ) {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('user');
    window.OneSignalDeferred = window.OneSignalDeferred || [];
  }

  ngAfterViewInit(): void {
    this.menuService._menu.next([]);
    this.userService.usuario.next(undefined);
  }

  ngOnInit(): void {
    this.storage.limpar();
    this.userService.permissao.next(undefined);
    this.userService.escola.next(undefined);
  }

  abrirTermos() {
    this.modalService.open(TermosPrivacidadeComponent);
  }

  setMenu() {
    const menu: Menu[] = [
      {
        icon: 'home',
        label: 'Inicio',
        route: '/admin/home',
        checked: true,
      },
      {
        icon: 'gavel',
        label: 'Termos',
        route: '/admin/termos',
        checked: false,
      },
    ];
    this.menuService.setMenu(menu);
  }

  entrar() {
    if (this.formLogin.valid) {
      this.loaderService
        .executeWithLoader(
          this.authService.logar(this.formLogin.value as AuthenticationRequest),
        )
        .subscribe({
          next: (response) => {
            if (response.user.blocked) {
              this.toastService.notify({
                message: 'Conta Desativada !',
                type: 'WARNING',
              });
              this.router.navigate(['/login']);
            }
            window.sessionStorage.setItem('token', response.jwt);
            const usuario: User = response.user;
            this.setMenu();
            window.sessionStorage.setItem('user', JSON.stringify(usuario));
            this.userService.usuario.next(usuario);
            if (window && (window as any).ReactNativeWebView) {
              (window as any).ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'LOGIN',
                  email: usuario.email,
                }),
              );
            }
            window?.OneSignalDeferred?.push(async function (OneSignal: any) {
              try {
                console.log('LOGIN PUSH' + usuario.email);
                console.log(OneSignal);
                await OneSignal.login(usuario.email);
              } catch (e) {
                console.log(e);
              }
            });

            this.router.navigate(['/admin/home']);
          },
          error: (erro) => {
            this.toastService.notify({
              message: erro.error.error.message,
              type: 'ERROR',
            });
          },
        });
    } else {
      this.campoObrigatorio = true;
      this.toastService.notify({
        message: 'Preencha o formulário corretamente !',
        type: 'WARNING',
      });
    }
  }
}
